import React, { useRef, useState, useEffect } from 'react'
import styles from './WeChatPay.module.css'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { message, QRCode, Result, Button } from 'antd'
import wechatIcon from './wechatIcon.svg'
import { checkPayResultRequest, getWXQrUrlRequest } from './api'
import qrcodeImg from './QR.svg'
let timeInterval = null
let checkPayInterval = null
let remainingTime = 15 * 60
export default function WeChatPay(props) {
  const dispatch = useDispatch()
  const [confirmInfo, setConfirmInfo] = useState({})
  const [messageApi, contextHolder] = message.useMessage()
  const [codeUrl, setCodeUrl] = useState('')
  const [payResult, setPayResult] = useState({
    result: 0,
    msg: '',
    subTitle: '',
  })
  const [time, setTime] = useState(remainingTime)
  useEffect(() => {
    timeInterval = null;
    checkPayInterval = null;
    setCodeUrl('')
    getWXQrUrl()
    return () => {
      // 组件卸载前移除事件监听
      clearInterval(timeInterval)
      clearInterval(checkPayInterval)
    }
  }, [props.amount])
  function getWXQrUrl() {
    if(props.amountListLength == 1){
      setTimeout(() => {
        getWXQrUrl()
      }, 800);
      return
    }
    clearInterval(timeInterval)
    clearInterval(checkPayInterval)
    setPayResult({
      result: 0,
      msg: '',
      subTitle: '',
    })
    getWXQrUrlRequest(props.amount, props.jifen, (res) => {
      console.log(res)
      if ('code_url' in res) {
        setTime(remainingTime)
        setCodeUrl(res.code_url)
        // timeLoop()
        let tempTime = remainingTime
        clearInterval(timeInterval)
        clearInterval(checkPayInterval)
        timeInterval = setInterval(() => {
          if (tempTime <= 0) {
            clearInterval(timeInterval)
            setPayResult({
              result: 2,
              msg: '    二维码过期，请刷新    ',
              subTitle: '        ',
            })
          }
          tempTime = tempTime - 1
          timeLoop(tempTime)
        }, 1000)
        checkPayInterval = setInterval(() => {
          checkPayResult(res.outTradeNo)
        }, 5000)
      } else {
        messageApi.error(res)
      }
    })
  }
  function timeLoop(tTime) {
    console.log(tTime)
    setTime(tTime)
  }
  function checkPayResult(dingdanCode) {
    checkPayResultRequest(dingdanCode, (res) => {
      if (res.ret==1) {
        setPayResult({
          result: 1,
          msg: "支付成功",
          subTitle: '    缴费时间' + res.data.jiaofei_time+ '    ',
        })
        clearInterval(checkPayInterval)
        setTimeout(() => {
          props.changePayWay(0)
        }, 3000);
      } else {
        messageApi.error(res.msg)
      }

      if (payResult.result != 0) {
        clearInterval(checkPayInterval)
        return
      }
    })
  }
  function formatSeconds(seconds) {
    // 处理负数情况
    if (seconds < 0) return '00:00:00'

    // 计算小时、分钟、剩余秒数
    const hour = Math.floor(seconds / 3600)
    const minute = Math.floor((seconds % 3600) / 60)
    const second = seconds % 60

    // 补零处理，确保都是两位数
    const format = (num) => num.toString().padStart(2, '0')

    return `${format(hour)}:${format(minute)}:${format(second)}`
  }
  return (
    <div className={styles.wechatPay}>
      <div className={styles.title1Div}>
        <img src={wechatIcon} className={styles.wechatIcon} />
        微信支付
      </div>
      <div className={styles.title2Div}>扫一扫积分充值</div>
      <div className={styles.title3Div}>{props.amount}元</div>
      {payResult.result == 0 ? (
        <QRCode
          errorLevel="H"
          value={codeUrl}
          style={{ marginTop: 20 }}
          size={180}
          // icon="https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
        />
      ) : (
        <img src={qrcodeImg} className={styles.qrcodeImg} />
      )}
      {codeUrl&&payResult.result == 0 && (
        <div style={{ fontSize: 12, color: '#E6521F', marginTop: 30 }}>
          请在15分钟内完成支付，{formatSeconds(time)}
        </div>
      )}
      {payResult.result != 0 ? (
        <Result
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
          }}
          status={payResult.result == 1 ? 'success' : 'error'}
          title={payResult.msg}
          // subTitle={
          //   payResult.result == 1
          //     ? `   交费时间：${new Date().toLocaleString()}   `
          //     : '        '
          // }
          subTitle={payResult.subTitle}
          extra={[
            // <Button type="primary" key="console">
            //   确认
            // </Button>,
            payResult.result == 2 ? (
              <Button
                type="primary"
                key="buy"
                style={{ marginLeft: 40, marginRight: 40 }}
                onClick={() => {
                  getWXQrUrl()
                }}
              >
                刷新二维码
              </Button>
            ) : null,
          ]}
        />
      ) : null}
    </div>
  )
}
// export default PaymentInfoList;

